// @flow

import React from 'react';
import { CSSTransition } from 'react-transition-group';

type Props = {
  active: boolean,
  onClick: Function,
  dummy: number,
  imageUrl: string,
};

const Dummy = (props: Props) => (
  <CSSTransition in={props.active} timeout={200} classNames="chase__dummy-active">
    <div className={`chase__dummy chase__dummy${props.dummy}`} onClick={props.onClick}>
      <img src={props.imageUrl} alt={''} className="chase__dummy-img" />
    </div>
  </CSSTransition>
);

export default Dummy;
